import { ref } from 'vue';
import { defineStore } from 'pinia';
import { recruitJsonCreate } from '@/api/recruitJson';
import { useAppSnackbar } from '@/stores/app/snackbar';

export const useSettingsTemplates = defineStore('settingsForm', () => {
  // Other Stores
  const { addErrorSnackbar } = useAppSnackbar();

  // Refs
  const showBaseListLoader = ref(false);

  // Mutations
  const setShowBaseListLoader = (value) => {
    showBaseListLoader.value = value;
  };

  // Actions
  const createNewTemplate = async (data) => {
    try {
      return await recruitJsonCreate(data);
    } catch (e) {
      addErrorSnackbar({
        text: `Error: Could not create item - ${e.message}`,
        timeout: 3500,
      });
      throw e;
    }
  };

  return {
    showBaseListLoader,
    setShowBaseListLoader,
    createNewTemplate,
  };
});
